import { ArrayList3it5z8td81qkl as ArrayList } from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/ArrayListJs.mjs';
import {
  ConcatenatedFormatStructure27s7lx6ixzw2f as ConcatenatedFormatStructure,
  NonConcatenatedFormatStructure1tep5eavrzcwp as NonConcatenatedFormatStructure,
} from './FormatStructure.mjs';
import { noWhenBranchMatchedException2a6r7ubxgky5j as noWhenBranchMatchedException } from '../../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import { Unit_instance3kz1zqli6gr1r as Unit_instance } from '../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { isInterface3d6p8outrmvmk as isInterface } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/typeCheckUtils.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
var AppendableFormatStructureClass;
function AppendableFormatStructure() {
  if (AppendableFormatStructureClass === VOID) {
    class $ {
      constructor() {
        var tmp = this;
        // Inline function 'kotlin.collections.mutableListOf' call
        tmp.list_1 = ArrayList().new_kotlin_collections_ArrayList_ony0vx_k$();
      }
      build_1k0s4u_k$() {
        return new (ConcatenatedFormatStructure())(this.list_1);
      }
      add_b6pdwl_k$(format) {
        if (isInterface(format, NonConcatenatedFormatStructure()))
          this.list_1.add_utx5q5_k$(format);
        else {
          if (format instanceof ConcatenatedFormatStructure()) {
            // Inline function 'kotlin.collections.forEach' call
            var _iterator__ex2g4s = format.formats_1.iterator_jk1svi_k$();
            while (_iterator__ex2g4s.hasNext_bitz1p_k$()) {
              var element = _iterator__ex2g4s.next_20eer_k$();
              this.list_1.add_utx5q5_k$(element);
            }
          } else {
            noWhenBranchMatchedException();
          }
        }
      }
    }
    initMetadataForClass($, 'AppendableFormatStructure', AppendableFormatStructure);
    AppendableFormatStructureClass = $;
  }
  return AppendableFormatStructureClass;
}
//region block: exports
export {
  AppendableFormatStructure as AppendableFormatStructure38mt32f1b8qva,
};
//endregion

//# sourceMappingURL=Builder.mjs.map
